import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PriceListSelect from "./PriceListSelect";

const mapStateToProps = (_state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PriceListSelect);
